import { extractApiErrorMessage } from './extractApiErrorMessage';

// Only a 422 is worded for the user; a 403 reads like "not allowed to …Policy#run?" or "Your roles…".
const isCustomerSafeRefusal = (status: number): boolean => status === 422;

/** The words for a refused call: the api's own for a 422, the fallback for any other status. */
export const refusalMessage = (
  error: Parameters<typeof extractApiErrorMessage>[0],
  fallback: string,
  noResponseMessage?: string
): string => {
  const status = error?.errorResponse?.response?.status;
  // Nothing came back, so axios's words are what tell this from a refusal, unless the caller has words of its own.
  if (!status) return noResponseMessage ?? (error?.message || fallback);

  return isCustomerSafeRefusal(status) ? extractApiErrorMessage(error, fallback) : fallback;
};

/** A 404: what the call named is gone, so trying again can't succeed. */
export const isNotFoundRefusal = (error: Parameters<typeof extractApiErrorMessage>[0]): boolean =>
  error?.errorResponse?.response?.status === 404;
